export const OPEN_SNACKBAR = '@@snackbar/OPEN_SNACKBAR';
export const CLOSE_SNACKBAR = '@@snackbar/CLOSE_SNACKBAR';



// WEBPACK FOOTER //
// ./src/redux/snackbar/types.js